import firebase from 'firebase/app'
import 'firebase/firestore'

export default {
  async fetchLineSettings ({ state, commit }) {
    // Fetch once per app lifecycle
    if (state.loaded && state.lineAt && state.linkLine) return
    try {
      const doc = await firebase.firestore().collection('settings').doc('line').get()
      if (doc.exists) {
        const data = doc.data() || {}
        commit('SET_LINE_SETTINGS', {
          lineAt: data.lineAt || '',
          linkLine: data.linkLine || ''
        })
      } else {
        commit('SET_LINE_SETTINGS', { lineAt: '', linkLine: '' })
      }
    } catch (e) {
      // ignore; fall back to defaults in components
    } finally {
      commit('SET_SETTINGS_LOADED', true)
    }
  }
}

